import { EVENTS_BY_PATH, TrackingEvent } from "@ncs/web-legos/util"
import { useRef } from "react"

import AnalyticsClient, { authUser } from "~/util/analytics-client"
import { trackEvent as trackEventGA } from "@ncs/web-legos/util"

type Experiment = {
	name: string
	variants: string[]
}

export enum ExperimentVariant {
	OFF = "off",
	ON = "on",
	VARIANT_A = "variant-a",
	VARIANT_B = "variant-b",
	VARIANT_C = "variant-c",
}

export enum EXPERIMENT_NAMES {
	TEST_EXPERIMENT = "feature_flag_testing",
}

const buildExperiment = (name: string, variants: string[]) => {
	return {
		name,
		variants,
	}
}

export const EXPERIMENTS_COLLECTION: Record<string, Experiment> = {
	[EXPERIMENT_NAMES.TEST_EXPERIMENT]: buildExperiment(EXPERIMENT_NAMES.TEST_EXPERIMENT, [
		ExperimentVariant.OFF,
		ExperimentVariant.ON,
		ExperimentVariant.VARIANT_A,
		ExperimentVariant.VARIANT_B,
		ExperimentVariant.VARIANT_C,
	]),
}

export const useAnalytics = () => {
	const resetAnalytics = () => {
		AnalyticsClient.getInstance().reset()
	}
	const lastPath = useRef("")

	const identify = (user: authUser) => {
		AnalyticsClient.getInstance().identify({
			id: user.id,
			email: user.email,
			name: user.name,
			punchOutSessionId: null,
		})
	}

	const trackEvent = (
		event: TrackingEvent | string,
		data?: Record<string, any>,
		timeout = 0
	) => {
		AnalyticsClient.getInstance().trackEvent(event, data, timeout)
		trackEventGA(event, data, timeout)
	}

	const fetchExperiments = () => {
		AnalyticsClient.getInstance().fetchExperiments()
	}

	const getExperimentCurrentVariants = () => {
		return AnalyticsClient.getInstance().getExperimentCurrentVariants()
	}

	const trackCustomerPortalNavigation = (location: string) => {
		if (!location) return
		const normalizedLocation = location.toLowerCase()
		const path = Object.keys(EVENTS_BY_PATH).find((p) => normalizedLocation.includes(p))
		if (path && path !== lastPath.current) {
			lastPath.current = path
			trackEvent(EVENTS_BY_PATH[path])
			setTimeout(() => (lastPath.current = ""), 1000)
		}
	}

	const getExperimentVariantData = (experimentName: string) => {
		return AnalyticsClient.getInstance().getExperimentVariantData(experimentName)
	}

	const startExperiment = () => {
		AnalyticsClient.getInstance().startExperiment()
	}

	return {
		resetAnalytics,
		identify,
		trackEvent,
		fetchExperiments,
		getExperimentCurrentVariants,
		trackCustomerPortalNavigation,
		getExperimentVariantData,
		startExperiment,
	}
}
